module.exports = __webpack_public_path__ + "static/img/challenge1.749c777.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/xi/challenge/challenge1.png
// module id = kAJm
// module chunks = 1